// This file is automatically generated by the "mapping" process

interface Mapping {
  [clientId: string]: string;
}

const mapping = {
  "0z8A2TTrsNsvssWMPnhctiYo4BEJp9Jx": "https://shoptest.snowshoemtn.com/login",
  Cox1fP8ihDFeoo0msuFK9ZijYUz2h1Ss:
    "https://altr-test.us.auth0.com/login/callback",
  VGiF5KfY54E76Dvft7SjPlGwM4CcIGsY: "https://shoptest.steamboat.com/login",
  AXtt9splKTCSezTUDb2Bug1B1lpcVrwq:
    "https://shoptest.solitudemountain.com/login",
  getv8npbLwMfkOslwMPvKtwRNrOtGYQd: "https://shoptest.stratton.com/login",
  QddULTrtSPp2eEpqQ0sgYA9G395Ochtq:
    "https://shoptest.winterparkresort.com/login",
  "2MXw89TkHnn4mZUAFDTjeXDX4kMQ4K5T": "https://shoptest.steamboat.com/login",
  e3pBaHW6vb8LtZtx7azaNQSR0pv65GOe: "https://shoptest.palisadestahoe.com/login",
  "9zE1VXZE1XFVXtm2GSpgzKf8bj0viyU5": "https://account.qa.ikonpass.com/login",
  uYfmIfxkRNlmhVOB4FmPS9duRwdSLC9u: "https://account.qa.ikonpass.com/login",
  M42ZYQ19ef9JEDOdlDS6KYeK12zdjdMM: "https://account.qa.ikonpass.com/login",
  Mlk3oTXxS5sazNUqLRpBbE0NNILQSkCG: "https://account.qa.ikonpass.com/login",
  TeuzOaRLZCiAfr1fMSJdiMQum7MatRN9: "https://account.qa.ikonpass.com/login",
  z4unBLYVhOhiegtmnYjMregKxY2T9DQq: "https://account.qa.ikonpass.com/login",
  "2H9fZTUitHmMKmNu6JryiFe4nx4E0vDc": "https://account.qa.ikonpass.com/login",
  T81stvByfVCXXByRFIJku5XTdsjFIxk8: "https://account.qa.ikonpass.com/login",
  repdjS21vAhZLRNuWZkM1oYtnm3PfwpM: "https://account.qa.ikonpass.com/login",
  upT6NyXWZpyJ0f5Az6pksopE2AwrykDW: "https://account.qa.ikonpass.com/login",
  eI08pJc2ePcViNLqxpMzt79nRldVfGrz: "https://account.qa.ikonpass.com/login",
  guLJYmkBRZDxLclMDo5DPPYnvNuOoRht: "https://account.qa.ikonpass.com/login",
  EfQBri9OaOdSel8REaTXDrNOKcWcgjah: "https://account.qa.ikonpass.com/login",
  dXX4YpYQgJjDfreHWNmJx5kkKcamN0Wt: "https://account.qa.ikonpass.com/login",
  wUOCHcMFXqn5jUH3qxKHJtjZOyuK0TkB: "https://account.qa.ikonpass.com/login",
  "0VCmjFE8UydCIIjwbCD42BrYioOfLyWK": "https://account.qa.ikonpass.com/login",
  vI4Kbh16JO2NvgCrHVc4NB1H7xWaAuYM: "https://account.qa.ikonpass.com/login",
  CtQhVW6phOk8QhX7ukTVE4lXJyPS7vAj: "https://account.qa.ikonpass.com/login",
  ZnwGmk8ohWYAHTBrsV1GvrV0BQFbEP0D: "https://account.qa.ikonpass.com/login",
  "6BaAtQNFBWek7a7cCYYSkBwOTuJr86yq": "https://account.qa.ikonpass.com/login",
  lV7sCdULB7YApR3nzDT7SU5qS1PI2tVI: "https://account.qa.ikonpass.com/login",
  fflPt2vKS8cf4f33hCkHhEpA5RRwKFj5: "https://account.qa.ikonpass.com/login",
  VSEISSQmhlujgVELD7eg9r1iq0Bi4oUC: "https://account.qa.ikonpass.com/login",
  v2Wn7wZqBwR9VWBh3uSxflMNKFmRbVmj: "https://account.qa.ikonpass.com/login",
  "17vg63HgXd0MEqM5OzfDgga7UE8vHze3": "https://account.qa.ikonpass.com/login",
  EoVAWwXantpsmRLuuafe6Wr8zXn555Vb: "https://account.qa.ikonpass.com/login",
  FsfmGDfl1uh4pelbDaYouOXK2hHU3pdG: "https://account.qa.ikonpass.com/login",
  rrQ69DYuyY9RwmDksRVpSa9dqiFKyayX: "https://account.qa.ikonpass.com/login",
  Ot3DkGsGGRH4mzdOSjQO92Uxg4GJyHr0: "https://account.qa.ikonpass.com/login",
  mthzVr1nrfqroMeqKCoUBuLv9JO5Whwy: "https://account.qa.ikonpass.com/login",
  NFBlLRq8MVLVUzhvkG0wR4ZvQKGy5Ely: "https://account.qa.ikonpass.com/login",
  EE20PVxg7ZCb5KGTSgC3eGXGkqFmNUeh: "https://account.qa.ikonpass.com/login",
  ZmoOcB06lOwEXKU64HyRT9r5EUjAmGhU: "https://account.qa.ikonpass.com/login",
  "7zJ1JqPzEVui0fkNN5BTie6zXhxmU5IO": "https://shoptest.sugarbush.com/login",
} as Mapping;

export default mapping;
